module.exports = __webpack_public_path__ + "static/media/inquirer.52575085.svg";